
import { ProductSearchQueryArgs } from './api/models';
import { resolveRouterPath, router } from './router';
import { callAddToList, callRemoveFromList } from "./state/products";
import { selectUser } from "./state/users";
import { store } from "./store";
// const baseURL: string = (import.meta as any).env.BASE_URL;

export enum SupermarktEvents {
    SEARCH = 'smp-search',
    NAVIGATE = 'smp-navigate',
    ADD_TO_LIST = 'smp-addtolist',
    REMOVE_FROM_LIST = 'smp-removefromlist',
}

export class SearchEvent extends CustomEvent<ProductSearchQueryArgs> {
    constructor(args: ProductSearchQueryArgs, bubbles = true, composed = true) {
        super(SupermarktEvents.SEARCH, {
            bubbles: bubbles,
            composed: composed,
            detail: args
        });
    }
}

export class NavigateHomeEvent extends CustomEvent<{ url: string }> {
    constructor(bubbles = true, composed = true) {
        super(SupermarktEvents.NAVIGATE, {
            bubbles: bubbles,
            composed: composed,
            detail: {
                url: '/'
            }
        });
    }
}

export class NavigateEvent extends CustomEvent<{ url: string }> {
    constructor({ url }: { url: string }, bubbles = true, composed = true) {
        super(SupermarktEvents.NAVIGATE, {
            bubbles: bubbles,
            composed: composed,
            detail: {
                url,
            }
        });
    }
}

export class AddToListEvent extends CustomEvent<{ shopId: string, productRef: string }> {
    constructor({ shopId, productRef }: { shopId: string, productRef: string }, bubbles = true, composed = true) {
        super(SupermarktEvents.ADD_TO_LIST, {
            bubbles: bubbles,
            composed: composed,
            detail: {
                shopId,
                productRef
            }
        });
    }
}

export class RemoveFromListEvent extends CustomEvent<{ shopId: string, productRef: string }> {
    constructor({ shopId, productRef }: { shopId: string, productRef: string }, bubbles = true, composed = true) {
        super(SupermarktEvents.REMOVE_FROM_LIST, {
            bubbles: bubbles,
            composed: composed,
            detail: {
                shopId,
                productRef
            }
        });
    }
}

export const handleSearch = (event: Event) => {
    const searchEvent: SearchEvent = event as SearchEvent;
    const urlObject: URL = new URL(window.location.origin);
    urlObject.searchParams.set('q', searchEvent.detail.q || "");
    (searchEvent.detail?.category_ids || []).map(category_id=>urlObject.searchParams.append('category_ids', category_id)); // multiple
    (searchEvent.detail?.shop_ids || []).map(shop_id=>urlObject.searchParams.append('shop_ids', shop_id));
    const relativePath: string = `search` + urlObject.search;
    router.navigate(resolveRouterPath(relativePath));
}

export const handleNavigate = (event: Event) => {
    const navigateEvent: NavigateEvent = event as NavigateEvent;
    router.navigate(resolveRouterPath(navigateEvent.detail.url));
}

export const handleAddToList = (event: Event) => {
    const addToListEvent: AddToListEvent = event as AddToListEvent;
    const user = selectUser(store.getState());
    store.dispatch(callAddToList({
        uid: user ? user.uid : null,
        listId: store.getState().products.selectedListId,
        shopId: addToListEvent.detail.shopId,
        productRef: addToListEvent.detail.productRef,
    }));
}

export const handleRemoveFromList = (event: Event) => {
    const removeFromListEvent: RemoveFromListEvent = event as RemoveFromListEvent;
    const user = selectUser(store.getState());
    store.dispatch(callRemoveFromList({
        uid: user ? user.uid : null,
        listId: store.getState().products.selectedListId,
        shopId: removeFromListEvent.detail.shopId,
        productRef: removeFromListEvent.detail.productRef,
    }));
}

